import { Swiper, SwiperSlide } from "swiper/react";
import NetworkMediaFile from "../image/NetworkMediaFile";
// export const OverFlowBannerSwiper = ({ ls }: { ls?: MediaFile[] }) => {
//   if (!ls?.length) return null;
//   if (ls.length === 1) {
//     return (
//       <div className="ui-container">
//         <NetworkMediaFile className="!h-[37.5rem] !w-full" file={ls[0]} />
//       </div>
//     );
//   }
//   return (
//     <div className="overflow-hidden w-[100vw] flex justify-center">
//       <Swiper
//         // initialSlide={2}
//         className="base-max-w !overflow-visible"
//         spaceBetween={24}
//         slidesPerView={1}
//         initialSlide={1}
//         navigation={false}
//         pagination={false}
//         autoplay={{ delay: 4000 }}
//         loop={true}
//         // onSlideChange={(swiper) => {
//         //   // load more slide
//         // }}
//         // loopAdditionalSlides={7}
//         // loopAdditionalSlides={10}
//         // loopAdditionalSlides={13}
//       >
//         {(ls ?? []).map((m) => (
//           <SwiperSlide
//             className="!h-[600px] !w-full base-max-w"
//             key={m.mediaFileId}
//           >
//             <NetworkMediaFile className="!h-[37.5rem] !w-full" file={m} />
//           </SwiperSlide>
//         ))}
//         {ls?.length === 2 &&
//           (ls ?? []).map((m) => (
//             <SwiperSlide
//               className="!h-[600px] !w-full base-max-w"
//               key={m.mediaFileId}
//             >
//               <NetworkMediaFile className="!h-[37.5rem] !w-full" file={m} />
//             </SwiperSlide>
//           ))}
//       </Swiper>
//     </div>
//   );
// };

export const OverFlowBannerSwiper = ({
  ls,
  onClick,
}: {
  ls?: MediaFile[];
  onClick?: () => void;
}) => {
  if (!ls?.length) return null;
  const className = "!h-[9.0625rem] sm:!h-[30rem] !w-full";

  if (ls.length === 1) {
    return (
      <NetworkMediaFile className={className} file={ls[0]} onClick={onClick} />
    );
  }
  return (
    <div className="flex justify-center overflow-hidden">
      <Swiper
        className={className}
        spaceBetween={24}
        slidesPerView={1}
        navigation={false}
        pagination={false}
        autoplay={{ delay: 4000 }}
        loop={true}
      >
        {(ls ?? []).map((m) => (
          <SwiperSlide className={className} key={m.mediaFileId}>
            <NetworkMediaFile
              className={className}
              file={m}
              onClick={onClick}
            />
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};
